import React, { Component } from 'react'
import { observer } from 'mobx-react'
import style from './style.module.less'
import Table from './Table'
import Menu from './Menu'
import SearchBar from './SearchBar'
import { isWeddingDressPhotoProperty } from '@merchant-backend/util'

@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.getMenuList()
  }
  render() {
    // const { statusCount } = this.props.store
    return (
      <div className={style.contentWrap}>
        <div className={style.categoryWrap}>
          <Menu store={this.props.store} />
        </div>
        <div className={style.tableWrap}>
          {isWeddingDressPhotoProperty() && (
            <SearchBar store={this.props.store} />
          )}
          <Table store={this.props.store} />
        </div>
      </div>
    )
  }
}
